import { ArticleDataType } from 'features/favourites/types'

export const extractSizeGuideDrawerData = (data): ArticleDataType => {
  const string = data.item?.rootCategoryPath?.split('/')
  const itemDepartment = string?.length === 3 ? string[2] : null
  return {
    code: data.item.code,
    department: itemDepartment,
    brandName: data.item.brandsData?.brandName,
    articleName: data.item.name,
  }
}
